<template>
    <div>
        <router-view @childrenRoute="hideNonChildren" />
        <div v-if="!isChildRoute">
            <div class="row m-3">
                <div class="col-md-12 mb-2">
                    <h4>POSTING BOS REPORT</h4>
                </div>
                
                <div class="col-md-12">
                    <el-card class="box-card col-md-12 mb-4" shadow="never" :body-style="{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '10px', paddingBottom: '16px' }">
                        <div slot="header" class="clearfix" v-if="false">
                            <h4>POSTING BOS REPORT</h4>
                        </div>
                        <div>
                            <el-tabs v-model="tabIndex" @tab-click="handleTabClick">
                                <el-tab-pane :label="'Shift Settlement'" :name="'0'">
                                    <PostingBosReportTab :tabIndex="'0'" :tabName="'shift_settlement'" :tabLabel="'Log Shift Settlement'"/>
                                </el-tab-pane>

                                <el-tab-pane :label="'EDC Detail'" :name="'1'">
                                    <PostingBosReportTab :tabIndex="'1'" :tabName="'edc'" :tabLabel="'Log EDC Detail'"/>
                                </el-tab-pane>

                                <el-tab-pane :label="'Transaction'" :name="'2'">
                                    <PostingBosReportTab :tabIndex="'2'" :tabName="'transaction'" :tabLabel="'Log WAA Transaction'"/>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import BarCard from '@/views/pages/BarCard.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import Loader from '@/components/loader/Loader2.vue'
import PieChart from '@/components/chart/Pie.js'
import { AxiosWithJar, Config, Penanggalan, FuelColor, Rainbow} from '@/utility.js'
import PostingBosReportTab from '@/views/pages/Maintenance/PostingBos/PostingBosReport/PostingBosReportTab.vue'

export default
{
	extends:Fuel,
	components: { 
		//ReportResultTable,
		//Loader,
        PostingBosReportTab,
	},
    data(){
		return {
            isChildRoute: false,
            tabIndex : '0',
			tabList:[
				{name:'Station'},
			],
        }
    },
	computed: {

	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
    },
    mounted() {
        this.hideNonChildren();
    },
    methods: {
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/maintenance/posting-bos/report';
        },
        handleTabClick(tab, event) {
            let tabIndex = tab.$vnode.key
            let tabName = tab.name
            let tabLabel = tab.label

            this.tab.index = tabIndex
            this.tab.name = tabName
            this.tab.label = tabLabel
        },

        getData() {

        },

        applyFilter() {
            this.getData()
        },
    },
}
</script>
